<template>
  <div>
    <my-editor ref="editor" :isReadOnly="isReadOnly" :contentHtml="contentHtml"></my-editor>
    <div class="control-box flex-c-c">
      <el-button type="primary" plain @click="goPre">上一步</el-button>
      <el-button type="primary" v-show="!isReadOnly" @click="goNext">发布</el-button>
      <el-button type="primary" v-show="isReadOnly" @click="handleBack">返回</el-button>
    </div>
  </div>
</template>
<script>
import MyEditor from "./components/my-editor.vue"
export default {
  components: {
    MyEditor
  },
  props: {
    detailInfo: {
      type: Object,
      default: () => { return {} }
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      contentHtml: ""
    }
  },
  watch: {
    detailInfo: {
      handler: function(val) {
        if (val.goodsDetail) {
          this.contentHtml = val.goodsDetail
        }
      }
    }
  },
  beforeDestroy() { // 解决富文本没清除 导致下次添加商品会把上一个商品的富文本照片从服务器删除的bug
    this.contentHtml = ""
  },
  methods: {
    // 返回
    handleBack() {
      this.$store.dispatch("tagsView/delView", this.$route).then(() => {
        this.$router.push({ name: "productGoodsManage" })
      })
    },
    // 上一步
    goPre() {
      this.$emit("pre")
    },
    // 下一步
    goNext() {
      this.$nextTick(() => {
        const editorResult = this.$refs.editor.getEditorResult()
        console.log("🚀 ~ this.$nextTick ~ editorResult:", editorResult)
        const deleteFiles = editorResult.insertImgList.filter(item => {
          // 插入的照片 找不到了 说明被删除了
          return !editorResult.resultImgList.includes(item)
        })
        const form = {
          deleteFiles,
          goodsDetail: editorResult.html
        }
        this.$emit("next", form)
      })
    }
  }
}
</script>
<style lang="scss" scoped></style>